import { NotificationService } from './notification.service';
import { Component, OnInit, SimpleChange } from '@angular/core';
import { Notifications } from './shared/notifications.model';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {

  private notifications: Notifications = new Notifications();
  private loader: any;
  private teste;

  constructor(
    private notificationService: NotificationService
  ) { }

  ngOnInit() {    
    this.notifications = this.notificationService.getNotification();
    this.loader = this.notificationService.getLoader();
  }

}


// WEBPACK FOOTER //
// ./src/app/notification/notification.component.ts